export default {
  landscape: 'Querformat',
  portrait: 'Hochkant',
};
